import React from 'react';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import { parameterBackupRequest } from './actions';
import './style.scss';
import PropTypes from 'prop-types';
const ParameterBackupComponent = ({ show, close, asset }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();
    const content = <div className='Parameter_backup_dialog__content'>
        <div>{translate('ABB.Powertrain.Frontend.TriggerParameterBackupDiscription')}</div>
    </div>;
    const getDeleteGatewayTitle = <h1 className='Parameter_backup_dialog__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='Parameter_backup_dialog__title-text'>{translate('ABB.Powertrain.Frontend.TriggerParameterBackupTitle')}</span>
    </h1>;
    return (
        <GeneralDialog
            show={show}
            close={close}
            id='parameter-backup-dialog'
            dialogClassName='Parameter_backup_dialog'
            closeButton={true}
            title={getDeleteGatewayTitle}
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.cancelLabel'),
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.TriggerParameterBackupLabel'),
                onClick: () => { dispatch(parameterBackupRequest(asset?.assetId)); close(); },
            }}
            persistent={false}
        >
            {content}
        </GeneralDialog>
    );
};
ParameterBackupComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.any,
};
export default ParameterBackupComponent;
